import AttendanceContainer from '../../../Components/Dashboards/Attendance'

export default function Attendance() {
    return (
        <div className='page-body'>
           <AttendanceContainer/>
        </div>
    )
}
